import { overrideOxylinkAuthBase } from './OxylinkAuthBase/OxylinkAuthBase';
import { overrideOxylinkConnectHeader } from './OxylinkConnectHeader/OxylinkConnectHeader';
import { overrideOxylinkMessage } from './OxylinkMessage/OxylinkMessage';

export const overrideOxylinkAuthComponents = () => {
    overrideOxylinkMessage();
    overrideOxylinkAuthBase();
    overrideOxylinkConnectHeader();
};
